define('AwaLabs.FacetsExtraConfig', [
    'Facets.Translator',
    'SC.Configuration',
    'underscore'
], function FacetsExtraConfig(
    FacetsTranslator,
    Configuration,
    _
) {
    'use strict';

    function addToSearchAPIMasterOptions(apiOptions) {
        var facetExclude = Configuration.get('facetsExtra.exclude') || [];
        var masterFacets = Configuration.get('facetsExtra.masterFacets') || [];

        _.each(apiOptions, function eachApiOptions(value) {
            _.each(masterFacets, function eachMasterFacet(masterFacet) {
                value[masterFacet.id] = masterFacet.value;
            });

            value['facet.exclude'] = value['facet.exclude'] ? value['facet.exclude'] + ',' + facetExclude.join(',') :
                facetExclude.join(',');
        });

        return apiOptions;
    }

    return {
        mountToApp: function mountToApp(application) {
            var Layout = application.getComponent('Layout');
            Layout.addToViewContextDefinition('Facets.Browse.View', 'type', 'string', function layoutType() {
                // NMS only use one view so we can use the default
                var displayOption = _.find(Configuration.get('itemsDisplayOptions'), function findDisplay(option) {
                    return option.isDefault;
                });
                return displayOption.id;
            });
            Configuration.searchApiMasterOptions = addToSearchAPIMasterOptions(
                Configuration.searchApiMasterOptions
            );
        }
    };
});
